import React from 'react'

import aiIcon1 from '../../assets/images/enterprise-ai/ai-icon-1.svg'
import aiIcon2 from '../../assets/images/enterprise-ai/ai-icon-2.svg'
import aiIcon3 from '../../assets/images/enterprise-ai/ai-icon-3.svg'
import { getEnterpriseAIContent } from '../../constants/enterpriseAIContent'

const PILLAR_ICONS = {
  efficiency: aiIcon1,
  speed: aiIcon2,
  governance: aiIcon3,
}

const PillarIcon = ({ type }) => (
  <img
    className="enterprise-ai-pillars__icon"
    src={PILLAR_ICONS[type]}
    alt=""
    width={56}
    height={56}
    loading="lazy"
    decoding="async"
  />
)

const EnterpriseAIValuePillars = ({ lang }) => {
  const { value } = getEnterpriseAIContent(lang)

  return (
    <section className="enterprise-ai-pillars" aria-labelledby="enterprise-ai-pillars-section-title">
      <div className="content container">
        {value.sectionTitle ? (
          <h2
            id="enterprise-ai-pillars-section-title"
            className="enterprise-ai-pillars__section-title"
          >
            {value.sectionTitle}
          </h2>
        ) : null}
        <div className="enterprise-ai-pillars__head">
          <h3 className="enterprise-ai-pillars__heading">{value.heading}</h3>
          <p className="enterprise-ai-pillars__lede">
            {value.lede}{' '}
            <span className="enterprise-ai-pillars__lede-accent">{value.ledeAccent}</span>
            {value.ledeTail ? ` ${value.ledeTail}` : ''}
          </p>
        </div>
        <div className="enterprise-ai-pillars__grid">
          {value.pillars.map(pillar => (
            <article key={pillar.title} className="enterprise-ai-pillars__card">
              <h3 className="enterprise-ai-pillars__card-title">{pillar.title}</h3>
              <PillarIcon type={pillar.icon} />
              <p className="enterprise-ai-pillars__card-body">{pillar.body}</p>
            </article>
          ))}
        </div>
        <p className="enterprise-ai-pillars__manifesto">{value.manifesto}</p>
      </div>
    </section>
  )
}

export default EnterpriseAIValuePillars
